import { render } from "./Language.vue?vue&type=template&id=74c47660&scoped=true&ts=true"
import script from "./Language.vue?vue&type=script&lang=ts"
export * from "./Language.vue?vue&type=script&lang=ts"

import "./Language.vue?vue&type=style&index=0&id=74c47660&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c47660"]])

export default __exports__